import api, { formatApiError } from "./api";

function filenameFromDisposition(disposition, fallback) {
    const encoded = disposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
    const plain = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
    const candidate = encoded ? decodeURIComponent(encoded) : plain;
    return (candidate || fallback || "export.xlsx").replace(/[\\/\r\n]/g, "-");
}

export async function downloadXlsx(path, params, fallbackFilename = "export.xlsx") {
    try {
        const response = await api.get(path, { params, responseType: "blob" });
        const url = URL.createObjectURL(response.data);
        try {
            const link = document.createElement("a");
            link.href = url;
            link.download = filenameFromDisposition(response.headers?.["content-disposition"], fallbackFilename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } finally {
            URL.revokeObjectURL(url);
        }
    } catch (error) {
        if (error?.response?.data instanceof Blob) {
            try {
                const body = JSON.parse(await error.response.data.text());
                error.response.data = body;
            } catch { /* retain the original Axios error */ }
        }
        throw new Error(formatApiError(error));
    }
}

export { filenameFromDisposition };
